module.exports = __webpack_public_path__ + "static/media/img_1-1ssi.7af774ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/img_1-1ssi.svg
// module id = 673
// module chunks = 0